import { render, staticRenderFns } from "./salesstatus.vue?vue&type=template&id=0f4798e9&scoped=true"
import script from "./salesstatus.vue?vue&type=script&lang=js"
export * from "./salesstatus.vue?vue&type=script&lang=js"
import style0 from "./salesstatus.vue?vue&type=style&index=0&id=0f4798e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4798e9",
  null
  
)

export default component.exports